import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';


@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  constructor(private apiService: ApiBaseService) { }



  /////// MAIL TEMPLATE CALLS

  async writeMailTemplate(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/WriteMailTemplate', payload, true, true);
  }

  async getAllMailTemplates(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/GetAllMailTemplates', payload, true, true);
  }
  async getMailTemplate(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/GetMailTemplate', payload, true, true);
  }
  async deleteMailTemplate(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/DeleteMailTemplate', payload, true, true);
  }
  async addMsgTriggerConfiguration(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/AddMsgTriggerConfiguration', payload, true, true);
  }
  async editMsgTriggerConfiguration(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/EditMsgTriggerConfiguration', payload, true, true);
  }
  async deleteMsgTriggerConfiguration(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/DeleteMsgTriggerConfiguration', payload, true, true);
  }
  async getAllTaskMsgTriggers(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/GetAllTaskMsgTriggers', payload, true, true);
  }
  async getTaskMsgTrigger(payload: any): Promise<any> {
    return this.apiService.httpRequest('MessagingService/GetTaskMsgTrigger', payload, true, true);
  }
  
}